import { Pageable, SortConfiguration } from 'types/rest/paginationTypes';
import _ from 'lodash';

/**
 * Utility which turns pageable object into string of query parameters
 * used by backend.
 * @param pageable
 */
export const buildPageableQueryParameters = (pageable: Pageable) => {
  return {
    limit: pageable.limit,
    skip: (pageable.skip - 1) * pageable.limit,
  };
};

/**
 * Builds sorting parameter for backend from sorting object used by Blaze Table.
 */
export const buildSortingParam = (sort?: SortConfiguration) => {
  if (_.isNil(sort) || !_.has(sort, 'sortKey') || _.isNil(sort.sortKey)) {
    return '-id'; //Default param is id, descending order
  }
  //Invert the sort by adding minus flag to the beginning of the string
  const flag = sort.direction === 'desc' ? '-' : '';
  return `${flag}${sort.sortKey}`;
};
